module.exports = __webpack_public_path__ + "img/guideBtn2.a0a3193f.png";